import { JSX, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../../common/hooks/useBreakpoints';
import {
  Notification,
  NotificationType,
} from '../../../../common/widgets/Notification';
import { Toast } from '../../../../common/widgets/Toast';
import { AccountInfoContext } from '../../contexts/AccountInfoContext';
import { resources } from '../../resources/resources';
import Footer from '../footer';
import { Header } from '../header';
import { Menu } from '../menu';

export default function MerchantsLayout(props: { children: JSX.Element }) {
  const { isTablet } = useBreakpoints();
  const { accountInfo } = useContext(AccountInfoContext);
  const { t: translate } = useTranslation();

  return (
    <div className="m-admin">
      <Header />
      <div className="toast-wrapper">
        <Toast />
      </div>
      <section className="section-main section-actions">
        <div className="container">
          <div className="area-actions">
            <Menu />
          </div>
          <div className="area-content">
            {accountInfo?.isImpersonating && (
              <Notification
                type={NotificationType.Warning}
                messages={[
                  {
                    message: translate(resources.impersonating),
                  },
                ]}
              />
            )}
            {props.children}
          </div>
        </div>
      </section>
      <Footer />
      {isTablet && <div className="mobile-nav-overlay"></div>}
    </div>
  );
}
